const PCCLoadingComponent = () => {
    return (
        <div className="flex flex-col items-center justify-center gap-y-4">
            <img src="/assets/icons/spinner.svg" alt="loading" className="w-10 h-10 animate-spin" />
            <p className="font-clash-display text-medium-dark-grey text-[24px] leading-[100%] tracking-[0%] text-center font-semibold">Verifying Employer Compliance</p>
            <p className="font-clash-display text-medium-dark-grey text-[14px] leading-[18px] tracking-[-0.5%] text-center">Please wait while we verify employer compliance status. This will take a few seconds.</p>
        </div>
    )
}

export default PCCLoadingComponent;